import {
  DEMO_FILL_JSON_FORM_FROM_UPLOAD_MUTATION_KEY,
  type FillJsonFormDemoFromUploadRequest,
  type FillJsonFormDemoResponse,
} from '@heidi/templates/contracts';
import { fillJsonFormDemoFromUpload } from '@heidi/templates/data';
import { useMutation } from '@tanstack/react-query';

export function useMutateFillJsonFormDemoFromUpload() {
  return useMutation<FillJsonFormDemoResponse, Error, FillJsonFormDemoFromUploadRequest>({
    mutationKey: DEMO_FILL_JSON_FORM_FROM_UPLOAD_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillJsonFormDemoFromUpload(request);
      return data;
    },
  });
}
